<template>
	<div
		:style="{ ...task.style, ...taskBarStyle, zIndex: hover ? 1 : 0 }"
		:class="['gantt-line', isEditable('drag') ? 'gantt-line--true' : 'gantt-line--false']"
		@mouseenter="setHoverPosition"
	>
		<div
			style="height: 100%; width: 100%"
			:class="isEditable('drag') ? 'grab' : ''"
			@mousedown="isEditable('drag') ? $emit('mouse-down-move') : ''"
			@click="barClickable ? $emit('click-bar') : false"
		>
			<p class="gantt-line__name" :style="taskBarNameStyle">
				<slot name="task-name" :task="task" />
			</p>
			<div
				v-if="isEditable('left') && (task.leftDot || dragging)"
				class="gantt-line__left"
				:style="`background-color:${task.style.borderColor};`"
				@mousedown.stop="isEditable('left') ? $emit('mouse-down-resize', 'left') : ''"
			>
				<span
					v-show="((isResize && leftResizing) || dragging) && task.id == taskBar.id"
					class="display-time-left"
				>
					{{ formatDisplayTimeLeft }}
				</span>
			</div>
			<div
				v-if="isEditable('right') && (task.rightDot || dragging)"
				class="gantt-line__right"
				:style="`background-color:${task.style.borderColor};`"
				@mousedown.stop="isEditable('right') ? $emit('mouse-down-resize', 'right') : ''"
			>
				<span
					v-show="((isResize && rightResizing) || dragging) && task.id == taskBar.id"
					class="display-time-right"
				>
					{{ formatDisplayTimeRight }}
				</span>
			</div>
		</div>
		<slot
			name="hover-card"
			:hover="hover"
			:task="task"
			:hoverPosition="hoverPosition"
			:taskLine="taskLine"
		/>
	</div>
</template>

<script>
export default {
	props: {
		task: {
			type: Object,
			required: true,
		},
		taskBar: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		taskBarStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		hover: {
			type: Boolean,
			required: false,
			default: false,
		},
		// true or false or { left: true, right: true, drag: true}
		editableStatus: {
			type: Boolean,
			required: false,
			default: false,
		},
		taskBarNameStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		rightResizing: {
			type: Boolean,
			required: false,
			default: false,
		},
		leftResizing: {
			type: Boolean,
			required: false,
			default: false,
		},
		dragging: {
			type: Boolean,
			required: false,
			default: false,
		},
		taskLine: {
			type: null,
			required: false,
			default: null,
		},
		formatDisplayTimeLeft: {
			type: String,
			required: false,
		},
		formatDisplayTimeRight: {
			type: String,
			required: false,
		},
		isResize: {
			type: Boolean,
			required: false,
			default: false,
		},
		barClickable: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			hoverPosition: {},
		}
	},
	methods: {
		setHoverPosition(e) {
			this.hoverPosition = e
		},
		isEditable(action) {
			if (this.editableStatus === true) {
				return true
			} else if (this.editableStatus === false) {
				return false
			} else {
				return this.editableStatus[action]
			}
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";

.gantt-line {
	position: absolute;
	height: 20px;
	border-bottom: 2px solid;
	border-color: orange;
	&__name {
		height: 100%;
		width: 100%;
		overflow: hidden;
		width: 100%;
		&:hover {
			background-color: rgba(255, 255, 255, 0.5);
			backdrop-filter: blur(2px);
		}
	}
	&__left {
		bottom: -4px;
		left: -4px;
		cursor: col-resize;
		position: absolute;
		background: orange;
		height: 8px;
		width: 8px;
		border-radius: 50%;
	}

	&__right {
		bottom: -4px;
		right: -4px;
		cursor: col-resize;
		position: absolute;
		background: orange;
		height: 8px;
		width: 8px;
		border-radius: 50%;
	}
	.display-time-left {
		background: whitesmoke;
		position: absolute;
		padding: 4px;
		font-size: 0.9rem;
		border-radius: 5px;
		bottom: 27px;
		text-align: center;
		opacity: 0.8;
	}

	.display-time-right {
		background: whitesmoke;
		position: absolute;
		padding: 4px;
		font-size: 0.9rem;
		border-radius: 5px;
		bottom: 27px;
		text-align: center;
		opacity: 0.8;
		right: 6px;
	}
}

.grab {
	cursor: grab;
}
</style>
